import {withStyles} from "@mui/styles";
import styles from "./AppStructure-jss";
import {Box, CssBaseline, useTheme} from "@mui/material";
import LeftMenu from "../MainMenu/MainMenu";
import { styled } from '@mui/material/styles';
import {Outlet} from "react-router-dom";

type Properties = {
    classes: any,
    children: any,
}

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    backgroundColor: theme.palette.background.default,
}));

function AppStructure(props: Properties) {
    const {
        children,
    } = props;
    const theme = useTheme();

    return (
        <Box sx={{ display: 'flex', backgroundColor: theme.palette.background.default, minHeight: '100vh' }}>
            <CssBaseline />
            <LeftMenu />
            <Box component="main" sx={{ flexGrow: 1, p: 3, backgroundColor: theme.palette.background.default }}>
                <DrawerHeader />
                <Outlet />
            </Box>
        </Box>
    )
}

export default withStyles(styles)(AppStructure)
